import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateTimeToDateFormat, dateTimeToPlainFormat } from '@/utils'
import { BibliographyClass, CollectionFlag, Prefix } from '@/types'

export interface ReserveCancelCollection {
  id: number
  canceledTime: string
  canceledBranchCode: SystemCode
  canceledPlaceCode: SystemCode
  canceledReason: SystemCode
  bibliographyId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SystemCode
  displayMaterialFormat: SystemCode
  displayTitle: string
  displayAuthor: string
  reservedTime: string
  reservedBranchCode: SystemCode
  canceler: string
  memo: string
  collectionFlag: CollectionFlag
  revision: number
}

export function ReserveCancelCollectionFromJSON(
  json: any
): ReserveCancelCollection {
  return {
    id: exists(json, 'id') ? json.id : 0,
    canceledTime: exists(json, 'canceled_time')
      ? dateTimeToPlainFormat(json.canceled_time)
      : '',
    canceledBranchCode: exists(json, 'canceled_branch_code')
      ? SystemCodeFromJSON(json.canceled_branch_code)
      : defaultSystemCode(),
    canceledPlaceCode: exists(json, 'canceled_place_code')
      ? SystemCodeFromJSON(json.canceled_place_code)
      : defaultSystemCode(),
    canceledReason: exists(json, 'canceled_reason')
      ? SystemCodeFromJSON(json.canceled_reason)
      : defaultSystemCode(),
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Set,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayMaterialFormat: exists(json, 'display_material_format')
      ? SystemCodeFromJSON(json.display_material_format)
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    reservedTime: exists(json, 'reserved_time')
      ? dateTimeToDateFormat(dateTimeToPlainFormat(json.reserved_time))
      : '',
    reservedBranchCode: exists(json, 'reserved_branch_code')
      ? SystemCodeFromJSON(json.reserved_branch_code)
      : defaultSystemCode(),
    canceler: exists(json, 'canceler') ? json.canceler : '',
    memo: exists(json, 'memo') ? json.memo : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
